import api from '@services/api';
import { DetailsRequest, UndoUnionDetailsRequest, UnitDetailsRequest } from '../models/details';
import {
  RelatedServiceResponse,
  RelatedServiceTransfer,
  UpdateDetailsRelatedService,
} from '../models/detailsRelatedService';

/**
 * <p>
 * API endpoints that cover all details related service related CRUD calls
 */
export const detailsRelatedServiceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchRelatedService: builder.query<RelatedServiceResponse, DetailsRequest>({
      query: (params: DetailsRequest) => ({
        url: encodeURI(
          `report/details-relatedservice/search?searchTerm=${params.searchTerm}&projectCode=${params.project}&period=${params.period}&subgroup=${params.subGroup}`,
        ),
      }),
      providesTags: ['SearchRelatedService', 'SearchDetails'],
    }),
    updateDetailsRelatedService: builder.mutation<void, UpdateDetailsRelatedService>({
      query: (project) => ({
        url: encodeURI(`/report/details-relatedservice/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['SearchRelatedService'],
    }),
    unitDetailsRelatedService: builder.mutation<void, UnitDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-relatedservice/group`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchRelatedService'],
    }),
    undoUnionDetailsRelatedService: builder.mutation<void, UndoUnionDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-relatedservice/ungroup`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchRelatedService'],
    }),
    realetedServiceTransfer: builder.mutation<void, RelatedServiceTransfer>({
      query: (project) => ({
        url: encodeURI(`/report/details-relatedservice/transfer`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchRelatedService', 'SearchDetailsConstruction', 'SearchDetails'],
    }),
  }),
});

export const {
  useSearchRelatedServiceQuery,
  useUpdateDetailsRelatedServiceMutation,
  useUnitDetailsRelatedServiceMutation,
  useUndoUnionDetailsRelatedServiceMutation,
  useRealetedServiceTransferMutation,
} = detailsRelatedServiceApi;
